import { render, staticRenderFns } from "./AdmissionMap.vue?vue&type=template&id=2f9f60c8&scoped=true&"
import script from "./AdmissionMap.vue?vue&type=script&lang=js&"
export * from "./AdmissionMap.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionMap.vue?vue&type=style&index=0&id=2f9f60c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f60c8",
  null
  
)

export default component.exports